import React, { useEffect, useRef } from "react";
import "./WebSnowfall.css";

interface WebSnowfallProps {
  duration?: number;
  maxSize?: number;
}

const WebSnowfall: React.FC<WebSnowfallProps> = ({
  duration = 600000,
  maxSize = 10,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const flakes = Array.from({ length: 80 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * maxSize + 2,
      speed: Math.random() * 1.5 + 0.5,
    }));

    let frameId: number;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "rgba(255,255,255,0.85)";
      flakes.forEach((f) => {
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fill();
        f.y += f.speed;
        f.x += Math.sin(f.y / 40) * 0.3;
        if (f.y > canvas.height) {
          f.y = -f.r;
          f.x = Math.random() * canvas.width;
        }
      });
      frameId = requestAnimationFrame(draw);
    };
    draw();

    const timer = setTimeout(() => {
      cancelAnimationFrame(frameId);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }, duration);

    return () => {
      cancelAnimationFrame(frameId);
      clearTimeout(timer);
      window.removeEventListener("resize", resize);
    };
  }, [duration, maxSize]);

  return <canvas ref={canvasRef} className="web-snowfall" aria-hidden />;
};

export default WebSnowfall;
